export default __webpack_public_path__ + "static/media/light.48fb7de6.svg";